import request from '../../axios';
import {IStoreListOrderPayload, IStoreListOrderResponse} from './types';

const storeListOrder = async ({
  pageParam,
  order_step,
}: IStoreListOrderPayload) => {
  const {data}: {data: IStoreListOrderResponse} = await request.get(
    '/api/v2/order/list-store-order',
    {
      params: {
        page: pageParam,
        order_step: order_step,
      },
    },
  );
  return data;
};

export default storeListOrder;
